import { deleteRequest, get, post, publicPost, put } from "../helpers/apihelpers";

export const CreateTemplateService=async(data)=>{
    try {
        const result = await post(`api/template/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateTemplateService=async(data,id)=>{
    try {
        const result = await put(`api/template/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetTemplateService=async(page,from_date,to_date,text)=>{
    try {
        const result = await get(`api/template/get?page=${page}&text=${text}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetAllTemplateService=async()=>{
    try {
        const result = await get(`api/template/get_all`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteTemplateService=async(id)=>{
    try {
        const result = await deleteRequest(`api/template/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}